import { DialogActions } from "@material-ui/core";
import React from "react";
import { RawLinkButton } from "../../../LinkButton";

interface INewIntegrationDialogActionsProps {
  submitNewForm: () => void;
  onClose: () => void;
}

export const NewIntegrationDialogActions = (props: INewIntegrationDialogActionsProps): JSX.Element => {
  const { submitNewForm, onClose } = props;
  return (
    <DialogActions>
      <RawLinkButton onClick={submitNewForm} color="primary">
        Submit
      </RawLinkButton>
      <RawLinkButton onClick={onClose} color="secondary">
        Close
      </RawLinkButton>
    </DialogActions>
  );
};
